export interface EmailValidationResult {
  isValid: boolean;
  error?: string;
}

export const validateEmail = (email: string): EmailValidationResult => {
  // Basic email validation
  if (!email) {
    return {
      isValid: false,
      error: "Email is required"
    };
  }

  if (!email.trim()) {
    return {
      isValid: false,
      error: "Email cannot be empty"
    };
  }

  // Email regex pattern
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  if (!emailRegex.test(email)) {
    return {
      isValid: false,
      error: "Please enter a valid email address"
    };
  }

  // Check for common invalid patterns
  if (email.length > 254) {
    return {
      isValid: false,
      error: "Email address is too long"
    };
  }

  // Check for consecutive dots
  if (email.includes('..')) {
    return {
      isValid: false,
      error: "Email address contains invalid characters"
    };
  }

  // Check for valid domain
  const domain = email.split('@')[1];
  if (domain && domain.length < 2) {
    return {
      isValid: false,
      error: "Please enter a valid domain"
    };
  }

  return {
    isValid: true
  };
};